'use strict';

import {throttle} from './../../../../build/node_modules/@components/throttle-debounce';

const $ = require('jquery');
const Template = require('./../lib/template');
const $filter = $('[data-lazy-load-area]');
const $loadOnScroll = $('[data-load-on-scroll]');

class FilterLazyLoad {

    constructor() {

        if ($filter.length > 0) {

            const Utility = require('./../lib/utilities');
            const LocationBar = require('./../lib/location-bar');
            const locationBar = new LocationBar();

            this.postType = $filter.data('post-type');
            this.$resultHolder = $filter.find('[data-results-holder]');
            this.$buttonHolder = $filter.find('[data-button-holder]');

            let $filterForm = $filter.find('[data-filter-form]');
            let $filterFormFields = $filterForm.find('input[type="checkbox"], input[type="radio"], select');

            let pagedTotal = $filter.data('lazy-total');
            let paged = 1;
            let scroll = true;

            locationBar.start({
                pushState: true
            });

            locationBar.onChange((path) => {

                this.loadItems(`/${path}`);
            });

            //  Handle all field of the form to process the filters (taxonomies)
            $filterFormFields.on('change', function () {

                $(this).closest($filterForm).submit();
            });

            //  Handle form submit
            $filterForm.on('submit', function (event) {

                event.preventDefault();

                let hash = window.location.hash;
                let pathname = window.location.pathname;
                //  Strip paginator from filter.
                //  When you're on page 2 and use the filter you need a new search, not a filtered page 2
                let url = pathname.replace(/page\/[0-9]\//g, '');

                //  Serialized form data
                let data = $(this).find(':input').filter(function (index, element) {
                    return $(element).val() != '';
                }).serialize();

                if (data) {
                    url += `?${decodeURIComponent(data)}`;
                }

                if (hash) {
                    url += hash;
                }

                App.Globals.$document.trigger('site:user:filter', data);

                //  Scroll to the top of the results
                App.Globals.$scrollAnimators.animate({
                    scrollTop: $filter.offset().top - $('#header').height()
                });

                //  Update URL
                locationBar.update(url, {trigger: true});
            });

            //  Reset filter
            $filter.on('click', '[data-filter-reset]', (event) => {
                event.preventDefault();

                let url = window.location.pathname;

                //  Reset radio/checkboxes
                this.resetFilters();

                App.Globals.$body.removeClass('filter-open');

                //  Update URL
                locationBar.update(url, {trigger: true});
            });

            $filter.on('click', '[data-trigger="filter"]', (event) => {
                event.preventDefault();

                App.Globals.$body.addClass('filter-open');
            });

            if ($loadOnScroll.length > 0) {
                App.Globals.$window
                    .on('scroll', throttle(200, () => {

                        let windowTop = App.Globals.$window.scrollTop();

                        if (windowTop + App.Globals.$window.height() > $filter.height() - 400) {

                            if (scroll) {

                                scroll = false;

                                if (paged < pagedTotal) {

                                    paged++;

                                    let urlParams = Utility.getURLParams();
                                    let websiteUrl = window.location.href;
                                    let pagination = 'page/' + paged + '/';

                                    websiteUrl = websiteUrl.split('?');
                                    let url = websiteUrl[0] + pagination;

                                    urlParams.json = 'true';

                                    $.ajax({
                                        url: url,
                                        data: urlParams,
                                        dataType: 'json'
                                    }).done((data) => {

                                        if (this.$resultHolder.length > 0) {

                                            data.ajax = true;

                                            if (this.postType === 'vacancy') {

                                                Template.render(this.$resultHolder.find('.vacancy-wrapper'), `${rk_globals.theme_path}/views/ajax/${this.postType}/set.twig`, data, true);
                                            } else {

                                                Template.render(this.$resultHolder, `${rk_globals.theme_path}/views/parts/${this.postType}/set.twig`, data, true);
                                            }

                                            scroll = true;
                                        }
                                    });
                                }
                            }
                        }
                    }));
            }

            this.$buttonHolder.on('click', 'a', (event) => {
                event.preventDefault();

                let href = event.currentTarget.href;
                let url = href.replace(/^.*\/\/[^\/]+/, '');
                let append = true;

                this.loadItems(url, append);
            });
        }
    }

    loadItems(url, append) {

        let $filterForm = $filter.find('[data-filter-form]');

        $.ajax({
            url: url,
            data: {
                json: true
            },
            dataType: 'json'
        }).done((data) => {

            //  Check if the taxonomy filter module exists and if any of the filters is active
            if (data.modules.taxonomy_filter !== undefined) {
                if (data.modules.taxonomy_filter.filter_active === true) {
                    $filterForm.addClass('filters-active');
                } else {
                    $filterForm.removeClass('filters-active');
                }
            }

            //  Load posts
            if (this.$resultHolder.length > 0) {
                if (data.pagination.current > 1) {
                    data.ajax = true;
                }

                Template.render(this.$resultHolder, `${rk_globals.theme_path}/views/parts/${this.postType}/set.twig`, data, append);
            }

            if (this.$buttonHolder.length > 0) {
                Template.render(this.$buttonHolder, `${rk_globals.theme_path}/views/parts/load-more.twig`, data);
            }


        });

    }

    /**
     *
     */
    resetFilters() {

        $('[data-filter-radio-holder] .radio, [data-filter-checkbox-holder] .checkbox')
            .removeClass('selected')
            .find('input')
            .prop('checked', false);
    }
}

module.exports = FilterLazyLoad;
